module.exports = __webpack_public_path__ + "static/media/undefinedb5a4c1b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/undefined.svg
// module id = 1344
// module chunks = 0